import SenderImageOptionState from '../store/schema/SenderImageOptionState';
import store from '../store/store';
import { updateUserConfiguration } from 'owa-options-core';
import OwaViewStateConfiguration from 'owa-service/lib/contract/OwaViewStateConfiguration';
import { getUserConfiguration } from 'owa-session-store';
import { action, select } from 'satcheljs/lib/legacy';
import { setBit, ListViewBitFlagsMasks } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';

export interface SaveSenderImageOptionState {
    optionState?: SenderImageOptionState;
    viewStateConfiguration: OwaViewStateConfiguration;
}

export default select<SaveSenderImageOptionState>({
    optionState: () => store,
    viewStateConfiguration: () => getUserConfiguration().ViewStateConfiguration,
})(async function saveSenderImageOptionFull(state?: SaveSenderImageOptionState) {
    const { optionState, viewStateConfiguration } = state;

    await saveSenderImageOption(optionState.showSenderImageInListView, viewStateConfiguration);
});

const saveSenderImageOption = action('saveSenderImageOption')(async function saveSenderImageOption(
    isEnabled: boolean,
    viewStateConfiguration: OwaViewStateConfiguration
) {
    setBit(!isEnabled, ListViewBitFlagsMasks.HideSenderImage);

    await updateUserConfiguration(
        [
            {
                propertyName: 'ListViewBitFlags',
                propertyType: 'Integer32',
                propertyValue: `${viewStateConfiguration.ListViewBitFlags}`,
            },
        ],
        'OWA.ViewStateConfiguration'
    );
});

export const onSenderImageToggle = select<SaveSenderImageOptionState>({
    viewStateConfiguration: () => getUserConfiguration().ViewStateConfiguration,
})(function(isEnabled: boolean, state?: SaveSenderImageOptionState) {
    saveSenderImageOption(isEnabled, state.viewStateConfiguration);
});
